import { FC, JSX } from "react";
import { signOut } from "firebase/auth";
import { auth } from "@/api/firebase/firebase.config";
import { Button } from "@radix-ui/themes";

const SignOut: FC = (): JSX.Element => {
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log("user signed out");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return <Button onClick={() => handleLogout()}>Sign out</Button>;
};

export default SignOut;
